<template>
   <div class="sc_component">
    <p class="sc_top_info">Save Survey Question Data:</p>


        <div v-if="is_saving_survey_question_data === false">      
            <div class="answer_input_contain">
            
                <div v-if="survey_question.input_type === 'text'">
                    <base-input
                        :placeholder="survey_question.survey_question_placeholder"
                        :name="survey_question.survey_question_uuid"
                        :id="survey_question.survey_question_uuid"
                        :required="survey_question.input_required"
                        class="full-width" 
                        v-model="survey_question_response_data"
                        
                    />
                </div>


                <div v-if="survey_question.input_type === 'textarea'">
                    <b-form-textarea
                        :placeholder="survey_question.survey_question_placeholder"
                        :name="survey_question.survey_question_uuid"
                        :id="survey_question.survey_question_uuid"
                        :required="survey_question.input_required"
                        class="full-width" 
                        :rows="survey_question.input_rows"
                        :max-rows="survey_question.input_max_rows"
                        v-model="survey_question_response_data"
                    
                    >
                    </b-form-textarea>
                </div>

                <div v-else-if="survey_question.input_type === 'checkbox'" class="survey_question_checkbox_contain">

                    <b-form-checkbox
                        class="full-width"
                        :placeholder="survey_question.survey_question_placeholder"
                        :name="survey_question.survey_question_uuid"
                        :id="survey_question.survey_question_uuid"
                        :checked="survey_question.input_checked_default"
                        :required="survey_question.input_required"
                        :unchecked-value="survey_question.input_xunchecked_value"
                        v-model="survey_question_response_data"
                    
                    >
                        <h3>{{survey_question.survey_question_placeholder}}</h3>
                    </b-form-checkbox>
                
                </div>

                <div v-else-if="survey_question.input_type === 'dropdown'" class="survey_question_dropdown_contain">
                
                        <b-dropdown variant="default" class="" id="inactive_sc_btn_2">
                            <template v-slot:button-content>
                                <span v-if="survey_question.input_icon_string" class="material-icons material-icons-outlined">{{survey_question.input_icon_string}}</span> {{survey_question.survey_question_placeholder}}
                            </template>
                            <b-dropdown-item v-for="(value) in survey_question.input_values"
                            :key="value.input_values"
                            :disabled="is_saving_survey_question_data"
                            @click="changeMsg(value)">
                                {{value}}
                            </b-dropdown-item>
                        </b-dropdown>

                        <base-button icon type="light" @click="close_survey_question_ui()" v-if="show_save_buttons === true">
                            <span class="btn-inner--icon material-icons material-icons-outlined md-18">close</span>
                        </base-button>
                
                </div>

                <div v-else-if="survey_question.input_type === 'range'" class="survey_question_range_contain">


                    <div class="range_label_contain">
                        <div class="range_label_left">
                            <p>Strong {{survey_question.input_min_name}}</p>
                        </div>
                        
                        <div class="range_label_right">
                            <p>Strong {{survey_question.input_max_name}}</p>
                        </div>
                        <div style="clear:both;"></div>
                    </div>
                    <div class="styled_range_input_contain">
                        <input type="range"
                        v-model=survey_question_response_data
                        :min=survey_question.input_min
                        :max=survey_question.input_max steps="1"

                        class="gradient-range" >
                    </div>
                    <div style="clear:both;"></div>
                    <div class="range_label_center">
                        <p>{{survey_question_response_data}}</p>
                    </div>
                </div>

            </div>

            <div class="save_sc_inline_contain" v-if="show_save_buttons === true">
                <div class="inline_sc_buttons" v-if="survey_question.input_type !== 'dropdown'">

                    <base-button icon type="primary" 
                        @click="changeMsg()"
                        :disabled="is_saving_survey_question_data"
                        >
                        <span class="btn-inner--icon material-icons material-icons-outlined md-18">assignment_turned_in</span>
                        <span class="btn-inner--text">Save Data</span>
                    </base-button>

                    <base-button icon type="light" @click="close_survey_question_ui()">
                        <span class="btn-inner--icon material-icons material-icons-outlined md-18">close</span>
                    </base-button>

                </div>
            </div>
        </div>

        <div v-else-if="this.is_saving_survey_question_data === true && show_save_buttons === true" class="sending_message_dots_centered">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="L4" x="0px" y="0px" enable-background="new 0 0 0 0" xml:space="preserve" viewBox="0 44 52 12">
                <circle fill="var(--blue)" stroke="none" cx="6" cy="50" r="6">
                    <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.1"/>    
                </circle>
                <circle fill="var(--blue)" stroke="none" cx="26" cy="50" r="6">
                    <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.2"/>       
                </circle>
                <circle fill="var(--blue)" stroke="none" cx="46" cy="50" r="6">
                    <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.3"/>     
                </circle>
            </svg>
        </div>
    </div>


</template>

<script>
    
    export default {
        name: 'survey_question_form',
       
        props: {
            msg: String,
            survey_question:{
                type: Object,
                // Object or array defaults must be returned from
            },
   
            show_save_buttons:{
                type:Boolean,
                default:false
            },
            value: {
                type: [String, Number],
                description: "Input value"
            }
        },
        data() {
            return {
                survey_question_response_data: '',
                is_saving_survey_question_data: false,
                draft_survey_question_answer_value: null,
                active_survey_question: {
                    "org_id":"d0ed245477da095ad3147488ba2b238b",
                    "front_team_id":"tim_2r841",
                    "script_uuid":"b6fc3d5b-c5ad-4210-a700-6ee225688540",
                    "survey_question_uuid":"032fb096-eb30-491e-a38a-e1dcf6663d6e",
                    "survey_question_name":"211118 survey question",
                    "survey_question_placeholder":"RSVP:",
                    "survey_question_form_id":"sc_input_rsvp",
                    "user_uuid_created":"bb77d9ac-7c4e-4255-a566-dcda2c1b07f1",
                    "user_uuid_last_modified":"bb77d9ac-7c4e-4255-a566-dcda2c1b07f1",
                    "date_created":"2021-11-18T19:05:23.156000000Z",
                    "last_modified":"2021-11-18T19:05:23.156000000Z",
                    "input_type":"dropdown",
                    "input_icon_string":"event",
                    "input_values":["Yes","No","Maybe"],
                    "input_required":true,
                    "input_checked_default":true,
                    "input_checked_value":null,
                    "input_min":1,
                    "input_max":5,
                    "input_min_name":null,
                    "input_max_name":null,
                    "input_max_rows":5,
                    "input_rows":3,
                    "input_render_value_handlebars":null,
                    "is_active":true,
                    "survey_question_data_type":"string",
                    "input_unchecked_value":null
                }
            }
        },
        computed: {
            
        },
        methods: {
            changeMsg(passed_value) {
                console.log('message emit from child component')
                if(passed_value && passed_value !== null) {
                    console.log(passed_value)
                    this.$emit("changeMsg", passed_value);
                } else {
                    this.$emit("changeMsg", this.survey_question_response_data);
                }    
            },
           
            close_survey_question_ui: function() {
                console.log('debug 209 close')
                this.$emit('close_survey_question_ui',true)
            },
           
        },
        mounted: function() {
            
        },
        watch: {
            
        }
    }

</script>
<style>
    .call_button_inline {
        vertical-align:text-bottom;
        margin-left: 10px;
        font-size:18px !important;
    }
    .contact_heading h1, .contact_heading span {
        display: inline-block;
        font-size: 32px;
        margin-bottom: 3px;
        vertical-align: middle !important;
    }
    .summery_item_col p {
        font-size:12px;
        margin-bottom:2px;
    }  
    .summery_item_col h3 {
        margin-top:0px;
        font-size: 38px;
    }
    .summery_item_col h4 {
        font-weight:normal;
    }
    .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
        background: #fff;
        color:#007aff;
    }
    .survey_questions_accordian .card {
        border: 1px solid rgba(0,0,0,.3);
    }
    .survey_questions_accordian .accordion > .card:first-of-type {
        border-bottom: 1px solid rgba(0,0,0,.3) !important;
    }
    .survey_questions_accordian .collapsed {
         background: rgba(0,0,0,.03);
    }
    .survey_questions_accordian .not-collapsed {
         background: var(--bg-white);
  
    }
    .survey_questions_accordian .not-collapsed h3 {

    }
    .survey_questions_header {
        text-align:left;
        font-size: 24px;
        font-weight: 600;

    }
    .survey_questions_header span {
        display:inline-block;
        font-size: 30px;
        vertical-align:sub;
    }
    .script_preview_contain_top, .script_preview_contain_bottom {
       max-width:500px; 
       margin:0 auto;
       border: 1px solid rgba(0,0,0,.3);
       padding: 10px;

    }
    .script_preview_contain_bottom {
        padding:10px 0px;
    }
    .script_preview_contain_top {
        border-radius: 8px 8px 0 0;
        box-sizing:border-box;
        overflow-x: hidden;
        overflow-y: auto;
        height:250px;
        display: flex;
        flex-direction: column;
    }

    #messages_container_scroll_loading {
       
    }
    .script_preview_contain_bottom {
        border-radius: 0px 0px 8px 8px;
        min-height:40px;
    }
    .script_preview_contain_top .row {
        flex-wrap: nowrap;
        margin-right: 15px;
        margin-left: 15px;
        align-content: center;
        justify-content: center;
        flex-direction: column;
    }

   .script_preview_contain {
       max-width:500px;
       border-radius: 5px;
       margin:0 auto;
       border: 1px solid rgba(0,0,0,.3);
       padding: 10px;
   }
   .script_preview_contain p {
       font-size: 12px;
       text-align:center;
       margin-bottom: 5px;
   }

    .messages {
        font-size:12px;
    margin-top: 5px;
    display: flex;
    flex-direction: column;
    }

    .message {
    border-radius: 20px;
    padding: 8px 15px;
    margin-top: 5px;
    margin-bottom: 5px;
    display: inline-block;
    }

    .yours {
    align-items: flex-start;
    }

    .yours .message {
    margin-right: 25%;
    background-color: #EEE;
    position: relative;
    }

    .yours .message.last:before {
    content: "";
    position: absolute;
    z-index: 0;
    bottom: 0;
    left: -7px;
    height: 20px;
    width: 20px;
    background: #EEE;
    border-bottom-right-radius: 15px;
    }
    .yours .message.last:after {
    content: "";
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: -10px;
    width: 10px;
    height: 20px;
    background: white;
    border-bottom-right-radius: 10px;
    }

    .mine {
    align-items: flex-end;
    }

    .mine .message {
    color: white;
    margin-left: 25%;
    background: rgb(0, 120, 254);
    position: relative;
    }

    .mine .message.last:before {
    content: "";
    position: absolute;
    z-index: 0;
    bottom: 0;
    right: -8px;
    height: 20px;
    width: 20px;
    background: rgb(0, 120, 254);
    border-bottom-left-radius: 15px;
    }

    .mine .message.last:after {
    content: "";
    position: absolute;
    z-index: 1;
    bottom: 0;
    right: -10px;
    width: 10px;
    height: 20px;
    background: white;
    border-bottom-left-radius: 10px;
    }
    .full-width {
        width: 100% !important;
    }
    .answer_input_contain {
        margin-bottom: 8px;
    }
    .answer_input_contain .form-group {
        margin: 0px;
    }
    
    .card-header {
        border-bottom: 0px !important;
    }
    .preview_info_text {
        font-size: 14px;
        margin:0px;
        text-align:center;
        margin:0 auto;
        font-style:italic;
    }
    .text_message_small_text {
        font-size: 12px;
        font-style:italic;
    }

    .script_message_button {

        padding-top:5px;
        padding-bottom:22px;
        text-align:center;
    }
    .script_message_button .btn-default {
        background: #fff;
        color: var(--gray-600);
        border: 1px solid var(--gray-300);
    }




input[type=range] {
    width: 100%;
}
.styled_range_input_contain {
    padding:0px 20px 0px 20px;
}



.gradient-range {
  width: 100%;
  height: 16px;
  background: linear-gradient(45deg, #ff3b30 10%, #602697 50%, #3399ff 90%);
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  outline: none;
  border-radius:8px;
}
.gradient-range::-webkit-slider-thumb {
  width: 2em;
  height: 2em;
  background: var(--white);
  border: 2px solid var(--blue);
  border-radius: 50%;
  -webkit-appearance: none;
          appearance: none;
  cursor: -webkit-grab;
  cursor: grab;
  -webkit-transition: border 1s;
  transition: border 1s;
}
.gradient-range::-webkit-slider-thumb:active {
  cursor: -webkit-grabbing;
  cursor: grabbing;
}
.gradient-range.green::-webkit-slider-thumb {
  border-color: #70c1b3;
}
.gradient-range.blue::-webkit-slider-thumb {
  border-color: #247ba0;
}
.gradient-range.yellow::-webkit-slider-thumb {
  border-color: #f3ffbd;
}
.gradient-range.crimson::-webkit-slider-thumb {
  border-color: #ff1654;
}








.survey_question_range_contain, .survey_question_dropdown_contain, .survey_question_checkbox_contain {
    margin-bottom: 10px;
    text-align:center;
}
.survey_question_checkbox_contain .custom-control {
    margin-top: 6px;
    padding-left: 17px;
}
.survey_question_range_contain p {
    margin:0px;
}
.survey_question_range_contain input[type=range] {
    margin-top: 5px;
}

.range_label_left {
    float:left;

    width: 30%;
    margin-right: 10%;
    text-align:left;
}
.range_label_left p, .range_label_right p {
    font-weight: bold;
    margin:0px;
    color: var(--gray-600);
}
.range_label_center {
    margin: 0 auto;
    text-align:center;
}
.range_label_center p {
    border-radius: 10px;
    background: var(--gray-100);
    width: 50px;
    margin: 0 auto;
}
.range_label_right {
    float:right;
    width: 30%;
    margin-left: 10%;
    text-align:right;
}


.survey_questions_accordian .card-body {
    padding-top:0px;
}

.quick_replies_contain ul {
    list-style:none;
    display:flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    margin:0 auto;
    margin-top: 15px;
    padding-left:0px;
}
.quick_reply_button {
    border: 1px solid var(--blue);
    border-radius: 16px;
    margin-right: 20px;
    cursor:pointer;
    padding: 6px 10px;
    font-size:12px;
    line-height:12px;
    text-align:center;
    color:var(--blue);
}
.quick_reply_button:hover {
    color:var(--blue-darker);
    border-color:var(--blue-darker);
    -webkit-box-shadow: 0 4px 6px rgb(50 50 93 / 11%), 0 1px 3px rgb(0 0 0 / 8%);
    box-shadow: 0 4px 6px rgb(50 50 93 / 11%), 0 1px 3px rgb(0 0 0 / 8%);
}
.quick_replies_contain p {
    font-size: 12px;
    text-align:center;
    color:var(--gray-400);
}
.reply_contain_flex {
   display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-direction: row;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    flex-direction: row;
    -ms-flex-wrap: nowrap;
    flex-wrap: wrap;
    -ms-flex-pack: center;
    -webkit-box-pack: center; 
    justify-content: space-around;
    -ms-flex-line-pack: center;
    align-content: center;
    -ms-flex-align: center;
    -webkit-box-align: center; 
    align-items: center;
}
.reply_box_left .btn {
    vertical-align:text-top;
    margin-top:1px;
    font-size:12px;
    font-weight:400;
    padding:4px 8px;
}
.send_area_icon .material-icons:hover {
    color:var(--blue-darker);
}

.reply_box_left .btn:hover,  {
    transform:none;
    background:var(--blue-darker);
}
.reply_box_left .material-icons {
    margin-top: -1px;
}
.float_left {
    float:left;
}
.reply_box_right {
    text-align:right;
    vertical-align:middle;
    line-height:36px;
}

.reply_box_middle .form-group {
    margin:0;
}
.reply_box_middle textarea.form-control {
    resize:none;
    width:100%;
    border-radius:18px;
    height:46px;
    min-width:320px;
    line-height:18px;
    font-size:12px;
    vertical-align:middle;
    padding:4px 12px 4px 12px;
}
.reply_box_middle textarea.long_reply_larger_box {
    height:68px !important;

}
.reply_box_middle textarea.long_reply_larger_box_double {
    height: 100px !important;
}
.send_area_emoji_icon {
    position:absolute;
    right:18px;
    top:2px;
}

.send_area_icon .material-icons {
    font-size:32px;
    top:2px;
}
.blue_border_top {
border-top: 1px solid var(--blue);
}
.quick_survey_question_contain {
    
    padding: 2px 8px 8px 8px;
    margin-top: 10px;
}
.sc_top_info {
    font-size:12px;
    text-align:center;
    margin:0px;
    padding:0 ;

}
.sc_button_center {
    margin: 0 auto;
    text-align:center
}
.inline_sc_buttons, .survey_question_dropdown_contain {
    margin: 0 auto;
    text-align:center
}
.survey_question_dropdown_contain .dropdown, .inline_sc_buttons .btn {
    margin-right: 20px;
}

.typing_svg svg, .sending_message_dots_centered svg {
    width: 32px;
}
.sending_message_dots_centered {
    margin: 0 auto;
    text-align:center;
}


    @media (max-width: 520px) {
        .mini_text_small_screen {
            font-size: 12px !important;
        }
    }
</style>
